import * as actions from "../actions";
import * as api from "../../api";
import { pushSourceToken } from 'utils';

export const getPayinUrl = (orderId, amount) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.getPayinUrl(token,orderId, amount);
  };
};

export const getUserCardList = (userId, subscriptionId = null, isSubscription = null) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getUserCardList(api.getUserCardList(token,userId, subscriptionId, isSubscription)));
  };
};

export const cardWebPayin = (orderId, amount, cardId, deleteCard, params = {}) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.cardWebPayin(token,orderId, amount, cardId, deleteCard, params);
  };
};

export const mangoPayCallback = (orderId, transactionId, deleteCard) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.mangoPayCallback(token,orderId, transactionId, deleteCard);
  };
};

export const createCardRegistration = (orderId, cardType, userId = null) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.createCardRegistration(api.createCardRegistration(token,orderId, cardType, userId)));
  };
};

export const getToken = (urlHetToken, data, accessKeyRef, returnURL, cardNumber, cardExpirationDate, cardCvx) => {
  return (dispatch, getState) => {
    return api.getToken(urlHetToken, data, accessKeyRef, returnURL, cardNumber, cardExpirationDate, cardCvx);
  };
};

export const deactivateCard = (cardId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.deactivateCard(token, cardId);
  };
};

export const refundWithMangoPay = (orderId, isCreditNote, creditNoteId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.refundWithMangoPay(token, orderId, isCreditNote, creditNoteId);
  };
};

export const FeedMangoWalletForOrganizationPayIn = (orderId, amount, cardId, deleteCard, params = {}, isCreditNote, creditNoteId, isRefund, redirectionURL, organizationId, userId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.FeedMangoWalletForOrganizationPayIn(token,orderId, amount, cardId, deleteCard, params, isCreditNote, creditNoteId, isRefund, redirectionURL, organizationId, userId);
  };
};

export const getOrganizationCardList = (clientId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getUserCardList(api.getOrganizationCardList(token,clientId)));
  };
};

export const cardRegistrationForOrganization = (clientId, cardType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.createCardRegistration(api.cardRegistrationForOrganization(token,clientId, cardType)));
  };
};

export const mangoPayCallbackForOrganization = (orderId, transactionId, deleteCard, creditNoteId , isCreditNote, amount, isRefund, redirectionURL, userId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.mangoPayCallbackForOrganization(token, orderId, transactionId, deleteCard, creditNoteId , isCreditNote, amount, isRefund, redirectionURL, userId);
  };
};

export const getOrganizationMangoBalance = (organizationId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.getOrganizationMangoBalance(token, organizationId);
  };
};

export const organizationPayout = (issuerId,amount) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.organizationPayout(token, issuerId,amount);
  };
};

export const createSubscription = (orderId, cardId,  params = {}) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.createSubscription(token,orderId, cardId, params);
  };
};

export const createMidCit = (orderId, subscriptionId,  params = {}) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.createMidCit(token,orderId, subscriptionId, params);
  };
};

export const updateSubscriptionCard = (subscriptionId, cardId, params = {}) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.updateSubscriptionCard(token, subscriptionId, cardId, params);
  };
};

export const createBankwire = (amount, tag, issuerId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.createBankwire(token, amount, tag, issuerId);
  };
};


export const getBankwires = (issuerId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.getBankwires(token, issuerId);
  };
};



// WEBPACK FOOTER //
// ./app/actions/thunks/mangoPay.js